module.exports = "/img/cruzFB.623441.png";